import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Slide,
    MenuItem,
    FormControl,
    InputLabel,
    Select
} from '@material-ui/core';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import WrappedTextField from 'common/components/custom/WrappedTextField';
import WrappedFromControlLabel from 'common/components/custom/WrappedFromControlLabel';
import { createUser, updateUser } from '../api/apiUsers';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class CreateOrUpdateUser extends Component {

    emptyUser = {
        firstName: '',
        lastName: '',
        email: '',
        enabled: false,
        role: ''
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            initialUser: JSON.parse(JSON.stringify(this.emptyUser)),
            user: JSON.parse(JSON.stringify(this.emptyUser)),
            modelToDelete: JSON.parse(JSON.stringify(this.emptyUser))
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.userToEdit != null) {
            if (prevState.user.id !== this.props.userToEdit.id) {
                this.setState({ user: this.props.userToEdit, initialUser: JSON.parse(JSON.stringify(this.props.userToEdit)) });
            }
        }
    }

    closeDialog = () => {
        this.props.onClose();
        this.setState({
            user: JSON.parse(JSON.stringify(this.emptyUser))
        });
    }

    handleChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        let { user } = this.state;

        user[name] = value;
        this.setState({ user: user })
    };

    createOrUpdateUser = (e) => {

        e.preventDefault()
        let { user } = this.state
        if (!this.validateForm()) {
            return;
        }
        let action = this.props.userToEdit ? updateUser : createUser;
        action(this.props.userToEdit ? user : user, { params: { clientId: this.props.userToEdit ? null : this.props.clientId } }).then(response => {
            this.props.enqueueSnackbar(
                this.props.t(this.props.userToEdit ? 'update_message_user' : 'create_message_user', { title: this.props.t('user') }), { variant: 'success' });
            this.closeDialog()
            this.props.getUsers(0)
        }).catch(error => {
            if (error.response.status === 400) {
                this.props.enqueueSnackbar(this.props.t("user_already_exists"), { variant: 'warning' });
            } else {
                this.props.enqueueSnackbar(
                    this.props.t(this.props.userToEdit ? 'error_update_message' : 'error_create_message', { title: this.props.t('user') }), { variant: 'error' });
            }
        });
    };

    validateForm() {
        let { user } = this.state;
        let valid = true;
        if (!user.firstName
            || !user.lastName
            || !user.email
            || !user.role
        ) {
            valid = false;
        }
        return valid;
    }

    render() {
        let { user, initialUser } = this.state

        let rolesList;
        if (this.props.roleList && this.props.roleList.length > 0) {
            rolesList = this.props.roleList.map((role, index) => {
                return <MenuItem key={index} value={role}>{role}</MenuItem>
            });
        }

        return (
            <Dialog onClose={this.closeDialog} open={this.props.userModalOpen} TransitionComponent={Transition}>
                <DialogTitle className="dialog-header-custom">{this.props.userToEdit ? this.props.t("edit_user") : this.props.t("new_user")}</DialogTitle>
                <form onSubmit={this.createOrUpdateUser} autoComplete="off" spellCheck="false">
                    <DialogContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"first_name"}
                                                name="firstName"
                                                onChange={this.handleChange}
                                                value={user.firstName}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"last_name"}
                                                name="lastName"
                                                onChange={this.handleChange}
                                                value={user.lastName}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"email"}
                                                name="email"
                                                onChange={this.handleChange}
                                                value={user.email}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={6} sm={6} md={7} lg={8} xl={8}>
                                        <Grid item container>
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel id="demo-simple-select-outlined-label" margin="dense">{this.props.t("role")}</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-outlined-label"
                                                    id="role"
                                                    name="role"
                                                    value={user.role}
                                                    onChange={this.handleChange}
                                                    label={this.props.t("role")}
                                                    size="small"
                                                    margin="dense">
                                                    {rolesList}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={6} sm={6} md={5} lg={4} xl={4}>
                                        <Grid item container>
                                            <WrappedFromControlLabel
                                                onChange={this.handleChange}
                                                name="enabled"
                                                checked={user.enabled || false}
                                                label={"enabled"}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent >
                    <DialogActions className={"dialog-actions-fix"}>
                        <Button color="inherit" onClick={this.closeDialog} variant="contained">
                            {this.props.t("close")}
                        </Button>
                        <Button type="submit" color="primary" variant="contained" disabled={this.props.userToEdit ? (JSON.stringify(user) === JSON.stringify(initialUser)) : !this.validateForm()}>
                            {this.props.userToEdit ? this.props.t("update") : this.props.t("create")}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        );
    }
}

export default withSnackbar(withRouter(withTranslation()(CreateOrUpdateUser)))
